import { render } from "./TheFooterContact.vue?vue&type=template&id=577783e1&scoped=true&ts=true"
import script from "./TheFooterContact.vue?vue&type=script&lang=ts"
export * from "./TheFooterContact.vue?vue&type=script&lang=ts"

import "./TheFooterContact.vue?vue&type=style&index=0&id=577783e1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577783e1"]])

export default __exports__